<script lang="ts">
  import type { ChannelDetail } from '../../../../../firebase/api/channel';
  import type { Feed, FeedAbstract } from '../../../../../firebase/common/feed';
  import type { Plan } from '../../../../../firebase/common/plan';
  import Layout from '../../../../../widgets/Layout.svelte';
  import FeedAbstPreview from './FeedAbstPreview.svelte';
  import FeedPreview from './FeedPreview.svelte';

  type PageFeedData =
    | {
        content: Feed;
        type: 'feed';
      }
    | {
        requiredPlan: Plan;
        content: FeedAbstract;
        type: 'abstract';
      };

  interface PageData {
    feed: PageFeedData;
    channel: ChannelDetail;
  }

  export let data: PageData;

  let currentCID: string | null;
  let prevCID: string | null;

  $: if (currentCID !== undefined) {
    if (prevCID !== undefined && prevCID !== currentCID && 'location' in globalThis) {
      location.reload();
    }

    prevCID = currentCID;
  }
</script>

<svelte:head>
  <title>{data.feed.content.title} by {data.channel.name} - AIFAN</title>
  <meta charset="utf-8" />
  <meta name="description" content={data.feed.type === 'abstract' ? data.feed.content.leading_text : ''} />
  <meta name="viewport" content="width=device-width,minimum-scale=1,initial-scale=1" />
  <meta name="format-detection" content="telephone=no, email=no, address=no" />
  <meta property="og:site_name" content="AIFAN" />
  <meta property="og:url" content="https://aifan.ai/c/{data.channel.display_name}/f/{data.feed.content.id}" />
  <meta property="og:type" content="website" />
  <meta property="og:title" content="{data.feed.content.title} by {data.channel.name} - AIFAN" />
  <meta property="og:description" content={data.feed.type === 'abstract' ? data.feed.content.leading_text : ''} />
  <meta property="og:image" content={data.feed.content.thumbnail} />
  <meta property="og:locale" content="ja_JP" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="@{data.channel.twitter_url ?? 'AIFAN_ai'}" />
  <meta name="twitter:title" content="{data.feed.content.title} by {data.channel.name} - AIFAN" />
  <meta name="twitter:description" content={data.feed.type === 'abstract' ? data.feed.content.leading_text : ''} />
  <meta name="twitter:image" content={data.feed.content.thumbnail} />
  <meta name="twitter:image:alt" content={data.feed.content.title} />
</svelte:head>

<Layout bind:currentCID>
  <div class="card">
    {#if data.feed.type === 'feed'}
      <FeedPreview feed={data.feed.content} channel={data.channel} owner={currentCID === data.channel.id} />
    {:else}
      <FeedAbstPreview
        feed={data.feed.content}
        requiredPlan={data.feed.requiredPlan}
        channel={data.channel}
        subscriber={currentCID}
      />
    {/if}
  </div>
</Layout>

<style lang="scss">
  $sp-width: 456px;
  $tb-width: 880px;
  .card {
    --body-width: 50rem;
    border-radius: 2rem;
    min-height: 100%;
    width: var(--body-width);
    margin: auto;
    overflow: hidden;
    position: relative;
    background-color: #fff;
  }

  :global(button.primary-styled) {
    transition: 200ms;
    appearance: none;
    border: none;
    background: var(--secondary-bg);
    display: flex;
    height: 3.6rem;
    font-size: 120%;
    width: 12rem;
    padding: 0.7rem 1.5rem;
    border-radius: 2rem;
    text-decoration: none;
    color: white;
    font-weight: bold;
    margin: 0.5rem auto;

    &:hover {
      filter: brightness(1.2);
    }

    &:active {
      filter: brightness(0.8);
    }

    div {
      margin: auto;
    }
  }

  @media screen and (max-width: #{$tb-width}) {
    .card {
      width: 100%;
      border-radius: 0;
      margin: -0rem 0 1.5rem;
    }
  }
</style>
